<template>
	<header-block title="Transaction" class="title"></header-block>
	<CustomerLoadWait :customer="((transaction && bankAccount) || transaction) && classificationOptions && availableTags" :cardBlocks="true" :withTopCard="true" />

	<div v-if="transaction && bankAccount && classificationOptions && classifications">
		<div class="transactionHeader">
			<span>{{ transaction.merchantName }}</span>
			<p>
				<span v-if="transaction.amount < 0">
					{{ formatter.format(transaction.amount * -1) }}
				</span>
				<span v-else>
					{{ formatter.format(transaction.amount) }}
				</span>
			</p> 
		</div>
			<div v-if="selectedClassificationId" class="centered">
				<MGButton @click="openDrawer()" 
					:text="_getClassificationNameByClassiciationId(selectedClassificationId)" 
					:arrow="false" 
					:open="true"
					:icon="_getIconByClassiciationId(selectedClassificationId) ? require('@/assets/transactions/' + _getIconByClassiciationId(selectedClassificationId).toLowerCase().replace('.svg', '.png')) : null"
					>
				</MGButton>
			</div>
			<div v-else class="centered">
				<MGButton 
					text="Please wait..." 
					:arrow="false" 
					:open="true"
					:disabled="true"
					>
				</MGButton>
			</div>
		<div style="clear:both; margin-bottom: 30px;"></div>
	</div>
	<transition>
		<div v-if="availableVoucher">
			<BarArrowButton v-if="!transaction.description.startsWith('MG*')" :icon="availableVoucher.merchant.logoUrl" @click="voucherClicked" :large="true" :title="'Buy a voucher for next time & save ' + formatter.format(Math.abs((transaction.amount / 100) * availableVoucher.discountPercentage))"></BarArrowButton>
			<BarArrowButton v-if="transaction.description.startsWith('MG*')" :icon="availableVoucher.merchant.logoUrl" @click="voucherClicked" :large="true" :title="'Buy another voucher for next time'"></BarArrowButton>
		</div>
	</transition>
	<div v-if="wellData">
		<WellPanel :data="wellData"/>
		<div class="hashTagsPanel">
			<div class="tag-label mb-2">#Tags</div>
			<TagInput v-if="transaction && availableTags"
				:selectableTags="availableTags"
				:modelValue="selectedTags"
				maxTags="5"
				maxTagLength="20"
				@change="handleTagsChange"
				@addedNew="handleNewTag"
			/>
		</div>
	</div>

	<DrawerPanel v-if="transaction && transactionClassifications" 
		ref="drawer" 
		openHeight="90%"
		:bottom="$route.query.inModal ? '-80px' : '0px'" title="Tag Transaction" backgroundColor="white" 
		openBackgroundColor="white"
		:confirmClose="confirmCloseDrawer"
	>
		<TransactionTagging v-if="suggestedClassificationReady && selectedClassificationId" :transaction="transaction" :categories="transactionClassifications" :currentSelectionId="selectedClassificationId"
				:suggestedClassification="suggestedClassification"
				@tag="onTagUpdated" @chosen="onClassificationChosen" @changed="onTransactionChanged" />
	</DrawerPanel>

	<MGDialog v-model="showConfirmDialog" title="Unsaved Changes" maxWidth="400px" contentHeight="150px">
		<template #content>
			<p>You have unsaved changes to the transaction classification. Are you sure you want to close without confirming the selected tag?</p>
		</template>
		<template #actions>
			<MGButton text="No, take me back" @click="cancelCloseDrawer" :alt="true" />
			<MGButton text="Yes, close without saving" @click="forceCloseDrawer" color="red" />
		</template>
	</MGDialog>
</template>

<script>

import Services from '../mixins/Services';
import SpendingAnalysis from '../mixins/SpendingAnalysis';
import Helpers from '../mixins/Helpers';
import Transaction from '../mixins/Transaction';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import WellPanel from './elements/WellPanel.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
import TransactionTagging from './elements/TransactionTagging.vue';
import MGButton from './elements/MGButton.vue';
import TagInput from './elements/TagInput.vue';
import BarArrowButton from './elements/BarArrowButton.vue';
import MGDialog from './elements/MGDialog.vue';

export default {
	// props: ['formatter'],
	mixins: [Services, Helpers, SpendingAnalysis, Transaction],
	components: { CustomerLoadWait, HeaderBlock, WellPanel, DrawerPanel, TransactionTagging, MGButton, TagInput, BarArrowButton, MGDialog },
	data() {
		return {
			classificationOptions: [],
			classifications: [],
			selectedClassificationId: null,
			selectedClassification: null,
			selectedTransactionGroup: [],
			suggestedClassificationReady: false,
			wellData: null,
			groupSize: null,
			selectedTags: [],
			availableTags: null,
			availableVoucher: null,
			hasUnsavedChanges: false,
			showConfirmDialog: false,
			originalClassificationId: null
		}
	},
	methods: {
		onLoad: async function() {
			this.fetchClassificationsAndTransactions();
		},
		voucherClicked: function() {
			if (window.parent) {
				window.parent.location = '/#/vouchers/amount/' + this.availableVoucher.id;
			} else {
				window.location = '/#/vouchers/amount/' + this.availableVoucher.id;
			}
		},
		fetchClassificationsAndTransactions() {
			this._getTransactionClassifications((result) => {
				this.classifications = result;
				this.classificationOptions = result.map(c => ({id: c.mgClassification.id, title: c.mgClassification.fullName}));
				this.getTransaction(this.$route.params.id);
				this._getCustomerTags(() => {
					console.log('Customer tags:', this.customerTags);
					this.availableTags = this.customerTags.map(t => t.tag);
				});
			});
		},
		getTransaction: function(id){
			this._getTransaction(id, () => {
				if (this.transaction && (this.transaction.effectiveClassification === null || this.transaction.effectiveClassification.mgClassification === "Uncategorised" || this.transaction.effectiveClassification.mgClassification === "Uncategorized") && this.transaction.merchantName) {
					this.suggestedClassificationReady = false;

					this._getSuggestedClassification(this.transaction.merchantName, () => {
						this.suggestedClassificationReady = true;
					});
				}
				else {
					this.suggestedClassificationReady = true;
				}
				this._getBankAccount(this.transaction.bankAccountID, () => {
					this.selectedClassificationId = this.transaction.effectiveClassification.id
					this.selectedClassificationName = this.transaction.effectiveClassification.mgSubClassification;
					var temp = [
						{order: 1, label: 'Date', value: this.transaction.timestampFormatted},
						{order: 3, label: 'Account', value: this.bankAccount.bank.name},
						{order: 4, label: 'Transaction', value: this.transaction.type === 'DEBIT' ? 'Money Out' : 'Money In'},
						{order: 5, label: 'Spending Analysis', value: this.transaction.excludeFromAnalysis ? 'Excluded' : 'Included'},
						{order: 6, label: 'Description', value: this.transaction.description},
					];
					if (this.transaction.timestamp.split('T')[1].split('.')[0] != "00:00:00")
					{
						temp.push({order: 2, label: 'Time', value: this.transaction.timestamp.split('T')[1].split('.')[0]});
					}
					// Initialize selectedTags from transaction data
					if (this.transaction.customerTags && Array.isArray(this.transaction.customerTags)) {
						this.selectedTags = this.transaction.customerTags.map(t => t.tag);
					} else {
						this.selectedTags = [];
					}
					this.wellData = temp;
				}, true);
				if (this.transaction.merchant) {
					this._searchAvailableVouchers(this.transaction.merchant.id, (r) => {
						if (r.length > 0) {
							this.availableVoucher = r[0];
						}
					});
				}
			})
		},

		updateClassification: function(transaction) {
			if (transaction.alwaysApplyTag || transaction.alwaysApplyExludeInclude) {
				this._createRule(transaction);
			}
			else {
				// update single transcation
				this._updateSingleTransaction(transaction);
			}
		},

		refresh: function() {
			this._clearTransactionsCache();
			this.getTransaction(this.transaction.id);
			this._getBankAccount(this.transaction.bankAccountID, null, /* lite: */ false, /*refreshCache: */ true); //Force cache refresh of bank transactions to reflect new classification
			this._getSpendingAnalysisStructured(null, /* refreshCache: */ true);
			this._getBankingInfo(null, /*refreshCache: */ true);
		},

		onTagUpdated: function(transaction) {
			this.hasUnsavedChanges = false;
			this.$refs.drawer.closeDrawer();
			this._onTagUpdated(transaction);
		},

		openDrawer: function() {
			this.originalClassificationId = this.selectedClassificationId;
			this.hasUnsavedChanges = false;
			this.$refs.drawer.openDrawer();
		},

		onClassificationChosen: function() {
			this.hasUnsavedChanges = true;
			this._scrollToBottom();
		},

		onTransactionChanged: function() {
			this.hasUnsavedChanges = true;
		},

		confirmCloseDrawer: function() {
			if (this.hasUnsavedChanges) {
				this.showConfirmDialog = true;
				return false;
			}
			return true;
		},

		forceCloseDrawer: function() {
			this.showConfirmDialog = false;
			this.hasUnsavedChanges = false;
			this.$refs.drawer.closeDrawer();
		},

		cancelCloseDrawer: function() {
			this.showConfirmDialog = false;
		},

		handleTagsChange(tags) {
			console.log('handleTagsChange', tags);
			const updatedTags = tags.map(newTag => {
				const existingTag = this.transaction.customerTags.find(t => t.tag === (newTag.tag || newTag));
				if (existingTag) {
					return { tag: existingTag.tag, id: existingTag.id };
				}
				return { tag: newTag.tag || newTag };
			});

			this._updateTransactionTags(this.transaction.bankAccountID, this.transaction.id, updatedTags, () => {
				console.log('refresh');
				this._clearCustomerTagsCache();
				this.refresh();
			});
		},	
	},
	mounted: function () {
		this.onLoad();
	},
}

</script>

<style scoped>

.transactionHeader {
	color: var(--text-color);
	font-size: 20px;
	text-align: center;
	padding-top: 30px;
	font-weight: bold;
	p{
		font-size: 20px;
		font-family: 'Gotham-Heavy';
		margin-top: 0px;
	};
	.small {
		font-size: 10px;
		margin-top: -40px;
	}
}

.title {
	font-size: 14px;
}

.tag-label {
	color: var(--text-color);
	font-size: 14px;
	font-weight: 500;
}

.hashTagsPanel {
	margin-top: -40px;
	margin-bottom: 20px;
	padding: 25px;
	background-color: white;
	border-radius: 24px;
}

</style>
